import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Checkbox = ({ name, checked, onChange, disabled, label }) => {
    return (_jsxs("label", { htmlFor: name, className: "fit-content mb-2 flex items-center text-sm", children: [_jsx("input", { className: "mr-2", type: "checkbox", name: name, id: name, checked: checked, onChange: onChange, disabled: disabled }), label] }));
};
export default Checkbox;
